import {RequestInfo} from "@khan/shared-core";

export const isTextToSpeechSupported = (guideLanguageCode: string): boolean => {
    // Currently voice generation is only fully supported in English.
    const supportedLanguages = new Set(["en", "es", "pt", "hi"]);
    if (
        !supportedLanguages.has(RequestInfo.kaLocale) ||
        !supportedLanguages.has(guideLanguageCode)
    ) {
        return false;
    }

    // Due to a bug in the Android Mobile App, we currently disable this
    // feature for the Mobile App on Android devices.
    if (RequestInfo.isMobileApp && !RequestInfo.isIOS) {
        return false;
    }

    return true;
};
